module.exports = __webpack_public_path__ + "img/tema-1-6.9b58839d.svg";